import { ReactElement } from 'react';

export default function BreSlideshowForm(): ReactElement | null {
  return null;
}
